// CustomerTypePieBusiness.tsx
import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import '../../Customers.scss'
import { formatNumber } from "../../../../services/mixin";
import { IDataDefaulFilter } from "..";
import { useNavigate } from "react-router-dom";


interface props {
    data?: {
        totalCustomer: number;
        totalIndividual: number;
        totalBusiness: number;
    }
    dataFilter: IDataDefaulFilter
}

const BUSINESS_ITEMS = [
    { key: "totalIndividual", name: "Cá nhân", color: "#1890FF", type: 0 },
    { key: "totalBusiness", name: "Doanh nghiệp", color: "#7B61FF", type: 1 },
] as const;

export const CustomerTypePieBusiness: React.FC<props> = ({ data, dataFilter }) => {
    const total = data?.totalCustomer ?? 0;
    const navigate = useNavigate()

    const chartData = BUSINESS_ITEMS.map((item) => ({
        name: item.name,
        value: data?.[item.key] ?? 0,
        color: item.color,
        type: item.type
    }));

    return (
        <div className="custom-page-css w-full flex h-full  flex-col justify-between items-center gap-6">
            <div className="custom-page-css w-240px h-240px">
                <ResponsiveContainer>
                    <PieChart>
                        <Pie
                            data={chartData}
                            dataKey="value"
                            outerRadius={110}
                            paddingAngle={2}
                        >
                            {chartData.map((entry, index) => (
                                <Cell
                                    key={index}
                                    fill={entry.color}
                                    onClick={() =>
                                        navigate(
                                            `/analysis-report/customers-card-list`,
                                            {
                                                state: {
                                                    firstPage: '/analysis-report/marketing-campaigns',
                                                    dataFilterCampaign: dataFilter,
                                                    typeBussiness: entry.type,
                                                    title: entry.type === 0 ? `Khách hàng là cá nhân` : `Khách hàng là doanh nghiệp`
                                                }
                                            }
                                        )
                                    }
                                />
                            ))}
                        </Pie>
                    </PieChart>
                </ResponsiveContainer>
            </div>

            {/* Legend */}
            <div className="space-y-2">
                {chartData.map((item) => {
                    const percent =
                        total === 0
                            ? "0"
                            : ((item.value / total) * 100).toFixed(1);
                    return (
                        <div key={item.name} className="flex items-center gap-2 text-sm">
                            <span
                                className="w-3 h-3 rounded-sm"
                                style={{ background: item.color }}
                            />
                            <span>
                                {item.name}: {formatNumber(item.value)} ({percent}%)
                            </span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
